import { Check, Clear } from "@mui/icons-material"
import { ListItemIcon, ListItemText, Menu, MenuItem, MenuList } from "@mui/material"
import { observer } from "mobx-react-lite"
import { FC } from "react"
import { useMenu } from "../../../../app/hook/useMenu"
import { IHomeTableFilterSession } from "../../../../app/stores/homeTableEquipmentStore"
import { HomeFilterButton } from "../../common/HomeFilterButton"
import { MinMax } from "../hook/useTable"

const options = [
    {
        label: '> 90%',
        value: {
            min: 90,
            max: null,
        },
    },
    {
        label: '70% - 90%',
        value: {
            min: 70,
            max: 89,
        },
    },
    {
        label: '50% - 70%',
        value: {
            min: 50,
            max: 69,
        }
    },
    {
        label: '< 50%',
        value: {
            min: null,
            max: 49,
        }
    }
]

interface Props {
    handleChange: (column: IHomeTableFilterSession, value: MinMax) => void;
    handleClear: (column: IHomeTableFilterSession) => void;
    filtered: MinMax;
    session: IHomeTableFilterSession;
}

const ProgressFilter: FC<Props> = ({ handleChange, handleClear: onClear, filtered, session }) => {
    const { anchorEl, isOpen, handleClose, handleOpen } = useMenu()

    const handleClear = () => {
        onClear(session)
        handleClose()
    }
    
    return (
        <>
            <HomeFilterButton color={filtered.min !== null || filtered.max !== null ? 'success' : 'default'} onClick={handleOpen} />
            <Menu open={isOpen} onClose={handleClose} anchorEl={anchorEl}>
                <MenuList sx={{ minWidth: '200px' }}>
                    <MenuItem onClick={handleClear}>
                        <ListItemIcon>
                            <Clear fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Clear</ListItemText>
                    </MenuItem>
                    {options.map((item, index) => {
                        let selected = filtered === item.value ?? false
                        return (
                            <MenuItem 
                                key={index} 
                                onClick={() => handleChange(session, item.value)} 
                                selected={selected}
                            >
                                {selected && <ListItemIcon><Check fontSize="small" /></ListItemIcon>}
                                <ListItemText inset={!selected}>{item.label}</ListItemText>
                            </MenuItem>
                        )
                    })}
                </MenuList>
            </Menu>
        </>
    )
}

export default observer(ProgressFilter)